import axios from "axios";
import VueCookies from "vue-cookies";
import { store } from "../src/store";
import jwt_decode from "jwt-decode";

const admin = VueCookies.get("admin");
const token = admin ? admin.token : "";
const domain = process.env.VUE_APP_DOMAIN;
const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`, //add access token,
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
//not compulsory but nice to have
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      if ((domain = "localhost")) {
        VueCookies.remove("admin", "/", "localhost");
        window.location = "/";
      } else {
        VueCookies.remove("admin", "/", `.${domain}`);
        window.location = "/";
      }
    }

    if (
      error.config.method === "get" &&
      error.response &&
      error.response.status === 403
    ) {
      store.commit("auth/unauthorised", true);
    }
    /** Handle errors **/
    return Promise.reject(error);
  }
);

api.interceptors.request.use(config => {
  if (
    config.headers.Authorization &&
    config.headers.Authorization.startsWith("Bearer")
  ) {
    if (
      config.url === "admin/dashboard" ||
      config.url === "auth/admin/users" ||
      config.url === "auth/admin/roles"
    ) {
      const token = config.headers.Authorization.split("Bearer ")[1];
      const decoded = jwt_decode(token);
      const roles = decoded.roles;
      const roleCheck = roles.find(el => el.role === "super admin");
      if (roleCheck) return config;
      // Check if user is not a super admin and the url path is not dashboard, then don't make any request and show the unauthorised page;
      else if (!roleCheck && location.pathname !== "/dashboard") {
        store.commit("auth/unauthorised", true);
        return;
      }
    } else return config;
  } else {
    return config;
  }
});

export default api;



//////////////////
// WEBPACK FOOTER
// ./services/apiService.js
// module id = null
// module chunks = 